import { defineComponent } from 'vue';
import { Close as CloseIcon } from '@element-plus/icons-vue';
import { FilterComponentEvents } from '@/models/app-internal/in-app-events.model';

export default defineComponent({
  name: 'ListFilterPopover',
  components: { CloseIcon },
  props: {
    filterTitle: {
      type: String,
      default: 'Filter',
    },
    resetButtonTitle: {
      type: String,
      default: 'Reset',
    },
    submitButtonTitle: {
      type: String,
      default: 'Apply',
    },
    isFilterLoading: {
      type: Boolean,
      required: true,
    },
    isFilterActive: {
      type: Boolean,
      required: true,
    },
  },
  emits: [
    FilterComponentEvents.CLOSE_FILTER,
    FilterComponentEvents.RESET_FILTER,
    FilterComponentEvents.SUBMIT_FILTER,
  ],
  setup(_props, { emit }) {
    const closeFilter = (): void => emit(FilterComponentEvents.CLOSE_FILTER);
    const resetFilter = (): void => emit(FilterComponentEvents.RESET_FILTER);
    const submitFilter = (event: Event): void => {
      event.preventDefault();
      emit(FilterComponentEvents.SUBMIT_FILTER);
    };

    return {
      closeFilter,
      resetFilter,
      submitFilter,
    };
  },
});
